<template>
    <div class="container">
        <div class="text-wrapper">
            <p class="contact">Fluent in frameworks</p>
            <p class="title">Frameworks I have mastered,</p>
            <p class="description">
                I have mastered React, Vue, Angular, and SvelteKit for building dynamic and efficient user interfaces.</p>
        </div>

        <div class="tabs-wrapper">
            <div class="left-section">
                <div class="tabs">
                    <button v-for="tab in tabs" :key="tab.name" :class="['tab', { active: tab.name === activeTab }]"
                        @click="setActiveTab(tab.name)">
                        {{ tab.name }}
                    </button>
                </div>
                <div class="code-section">
                    <CodeSnippet :key="activeTab" :code="activeCode" :language="activeLanguage"></CodeSnippet>
                </div>
            </div>
            <div class="right-section">
                <!-- <img :src="activeOutput" alt="Output Image" class="output-img"> -->
            </div>
        </div>
    </div>
</template>

<script>
import CodeSnippet from './CodeSnippet.vue';
export default {
    name: 'LoveToCode',
    data() {
        return {
            tabs: [
                { name: 'Vue', code: '<template>\n      <div>Hello Vue!</div>\n    </template>', language: 'markup' },
                { name: 'Angular', code: '<div>Hello Angular!</div>', language: 'html' },
                { name: 'React', code: 'const element = <h1>Hello, React!</h1>;', language: 'html' },
                { name: 'React Native', code: 'import { Text } from \'react-native\';\n<Text>Hello, React Native!</Text>;', language: 'html' },
            ],
            activeTab: 'Vue'
        };
    },
    components: {
        CodeSnippet
    },
    computed: {
        activeCode() {
            return this.tabs.find(tab => tab.name === this.activeTab).code;
        },
        activeOutput() {
            return this.tabs.find(tab => tab.name === this.activeTab).output;
        },
        activeLanguage(){
            return this.tabs.find(tab => tab.name === this.activeTab).language;
        }
    },
    methods: {
        setActiveTab(tabName) {
            this.activeTab = tabName;
        }
    }
}
</script>

<style scoped>
.container {
    background-color: var(--primary-bg-color);
    padding: 80px 120px;
    display: flex;
    gap: 32px;
    flex-direction: column;
    position: relative;
    overflow: hidden;
}

.text-wrapper {
    display: flex;
    gap: 12px;
    flex-direction: column;
    text-align: left;
}

.contact {
    font-size: 24px;
    font-weight: 500;
    background: linear-gradient(#B66BE1, #FF6267, #FFA84B);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.title {
    font-size: 2.5rem;
    font-weight: 600;
    color: var(--primary-text-color);
}

.description {
    font-size: 18px;
    color: var(--secondary-text-color);
}


.tabs-wrapper {
    display: flex;
    gap: 24px;
    flex: 1;
    min-height: 450px;
}

.left-section,
.right-section {
    background: linear-gradient(103.92deg, #0A0410 0.64%, #0D0C13 99.52%);
    border: 2px solid #252626;
    border-radius: 24px;
    display: flex;
}

.left-section {
    flex-direction: column;
    flex: 2;
}

.right-section {
    flex: 1;
}

.tabs {
    border-bottom: 2px solid #252626;
    /* padding: 16px 0px; */
    display: flex;
    /* gap: 16px; */
    overflow: auto;
}

.tab {
    padding: 16px 24px;
}

.tab.active {
    border-bottom: 2px solid #902B93;
}

.code-section {
    padding: 16px;
}


@media (max-width: 700px)  {
    .container {
        padding: 32px;
    }

    .title {
        font-size: 1.5rem;
    }

    .tabs-wrapper {
        flex-direction: column;
    }
}
</style>